/**
 * List of un implemented components which are present in formio.
 * This list is used to hide these menu items in the builder
 */
export default [
  'password',
  'radio',
  'selectboxes',
  'url',
  'email',
  'phoneNumber',
  'tags',
  'address',
  'day',
  'time',
  'currency',
  'survey',
  'signature',
  'content',
  'fieldset',
  'panel',
  'table',
  'tabs',
  'well',
  'recaptcha',
  'resource',
  'form',
  'sketchpad',
  'tagpad',
  'custom'
];
